/**
 * 路由导航辅助工具。
 *
 * @module navigation-helper
 */

/**
 * 从 URL pathname 提取 projectCode。
 *
 * 路径格式：`/app/{projectCode}/...`。
 * 返回 `undefined` 表示当前不在项目上下文中（如首页）。
 */
export const getProjectCodeFromPathname = (): string | undefined =>
  (/^\/app\/([a-z0-9]+.)\//.exec(location.pathname) || [])[1] || undefined;

/**
 * Full reload 到指定 URL（用于切换项目，触发时区重新初始化）。
 *
 * 函数内部赋值 `location.href` 后返回一个永不 resolve 的 Promise，
 * 确保调用方 `await` 后不会继续执行后续逻辑。
 *
 * @param url - 目标 URL（相对路径或同源绝对路径）；不传则 reload 当前页
 */
export async function fullReloadToAndAlwaysPending(url?: string): Promise<never> {
  const target = url ?? location.href;

  // 防御 open redirect：通过 URL 构造函数解析，统一比较 origin
  // 覆盖 http://、https://、// 协议相对路径等所有场景
  const resolved = new URL(target, location.href);
  if (resolved.origin !== location.origin) {
    throw new Error(`[fullReloadToAndAlwaysPending] Blocked cross-origin redirect: "${target}"`);
  }

  location.href = target;
  // 永不 resolve，确保后续代码不会执行
  return new Promise(() => {});
}
